module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div>\n<%\nvar scope, scopeID, scopeRoleID;\nfor(scopeID in model.toggleData){\nscope = model.toggleData[scopeID];\n%><div class=\"row\"><%\n%><%- include('../../base/form/elements/label', { model: { label: scope.name }}) %><%\n%><%- include('../../base/form/fields/toggle', { model: { dataTEXT: '', fieldCode: scopeID, 'text-data': scope.options, atom: { dataType: 'text' } }}) %><%\n%></div><%\n}\n%>\n</div>"
  , __filename = "components/templates/scopeTrees/selectScopeRoles.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n")
    ; __line = 2
    ; 
var scope, scopeID, scopeRoleID;
for(scopeID in model.toggleData){
scope = model.toggleData[scopeID];

    ; __line = 6
    ; __append("<div class=\"row\">")
    ; 

    ; __line = 7
    ; __append( include('../../base/form/elements/label', { model: { label: scope.name }}) )
    ; 

    ; __line = 8
    ; __append( include('../../base/form/fields/toggle', { model: { dataTEXT: '', fieldCode: scopeID, 'text-data': scope.options, atom: { dataType: 'text' } }}) )
    ; 

    ; __line = 9
    ; __append("</div>")
    ; 
}

    ; __line = 11
    ; __append("\n</div>")
    ; __line = 12
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/scopeTrees/selectScopeRoles.ejs

}